import "./Testimonials.css";

const testimonials = [
    {
        name: "Rabin Das",
        text: "This product is a saviour for me. Have been using for almost a year and it has been very smooth so far. GPS is fairly accurate and the exception notifications work well. The app is also very decent. Keeps record of the journey with every detail. Did not need support service so far so cannot comment. Hopefully it will be good aswell.",
        rating: 5,
    },
    {
        name: "mukundprem sai",
        text: "While I’m searching for the best range of gps vehicle tracking system and fuel sensors, I got a call from Sharon telematics Vizag team. It’s been 6months and it saved us almost 30lakhs in fuel expenses and operational cost.",
        rating: 5,
    },
    {
        name: "Gumpina Harish",
        text: "My experience with this company is quick response in customer support at any time. I am fixing a normal tracking device to my bike and it is working excellent.",
        rating: 5,
    },
    {
        name: "tammina naresh",
        text: "Thank you for prompt response on our queries. The tracker is good and have accurate data.",
        rating: 5,
    },
    {
        name: "Vasu Deva",
        text: "Good value for money, works well and has all the features working as advertised. Installation support was good.",
        rating: 5,
    },
    {
        name: "Gandreddi Charan12",
        text: "Very quick response from team and they installed AIS140 Mining Device for my mining company vehicles.",
        rating: 5,
    },
    {
        name: "Apparao Gandiboina",
        text: "Way4track app is simple and easy to operate, every detail is clear and we can track the exact location of vehicles.",
        rating: 5,
    },
    {
        name: "Anush Chukka",
        text: "While I was searching for AIS140 Mining GPS tracker device, I found way4track - they are official dealers.",
        rating: 5,
    },
];

export default function Testimonials() {
    return (
        <div className="testimonials-container-main">
            <div className="home-testimonials-container">

                <div className="testimonials-header">
                    {/* <span className="testimonial-tag">
                        Trusted by Thousands
                    </span> */}

                    <h2>
                        What Our Customers Say About
                        <span> Way4Track</span>
                    </h2>

                    <p>
                        Real experiences from businesses and vehicle owners
                        using our GPS tracking and fleet management solutions.
                    </p>
                </div>

                <div className="testimonials-scroll">
                    {testimonials.concat(testimonials).map((t, i) => (
                        <div key={i} className="testimonial-card">

                            {/* Stars */}
                            <div className="stars">
                                {"⭐".repeat(t.rating)}
                            </div>

                            {/* Text */}
                            <p className="testimonial-text">{t.text}</p>

                            {/* Footer */}
                            <div className="testimonial-footer">
                                <img
                                    src={"/images/user.png"}
                                    alt={t.name}
                                    className="avatar"
                                />
                                {/* <a className="user-info" href='https://share.google/CJTT1ngZSmmPIUCfE' target="_blank"
                                    rel="noopener noreferrer">
                                    <strong>{t.name}</strong>
                                </a> */}

                                <div className="user-info">
                                    <strong>{t.name}</strong>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}